import "./transactions.css";
import Layout from "../../layout";
import Table from "antd/lib/table";
import Select from "antd/lib/select";
import financeData from "../../data/finance_data";
import useTransactions from "../../hooks/use_transactions";
import { useEffect, useState } from "react";
import formatHelper from "../../helpers/format_helper";
import {
  CurrenciesEnum,
  RefundTypesEnum,
  TransactionsEnum,
} from "../../utils/enums";
import moment from "moment";
import Pagination from "antd/lib/pagination";
import DatePicker from "antd/lib/date-picker";
import { useSelector } from "react-redux";
import Skeleton from "../../components/skeleton";
import { dateHelper } from "../../helpers/date_helper";
import { formatAmount } from "../../helpers/format_amount";
import Tabs from "antd/lib/tabs";
import showFile from "../../helpers/show_file";
import { FaExternalLinkAlt } from "react-icons/fa";

const { RangePicker } = DatePicker;

const Transactions = () => {
  const {
    getCourses,
    getTransactions,
    getRefunds,
    courses,
    transactionsData,
    refundsData,
    filters,
    setFilters,
    paginates,
    loadings,
    getCoursesLoading,
  } = useTransactions();

  const [activeTab, setActiveTab] = useState("1");

  const userProfile = useSelector((state) => state.app.userProfile);

  const columns = [
    {
      title: "Course",
      dataIndex: "course.name",
      key: "course",
      width: 100,
      render: (_, data) => {
        return data.course?.name;
      },
    },
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      width: 100,
      render: (_, data) => {
        if (data.user?.fullname) {
          return data.user.fullname;
        }
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: 80,
      render: (_, data) => {
        return `${
          CurrenciesEnum.find((o) => o.value == data.currency).label
        } ${formatAmount(data.amount)}`;
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 140,
      render: (_, data) => {
        if (data.createTime) {
          return dateHelper(data.createTime);
        }
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (_, data) => {
        return (
          <div
            className="transactions_table_badge"
            style={{
              background: TransactionsEnum.find((o) => o.value == data.status)
                ?.color,
            }}
          >
            {TransactionsEnum.find((o) => o.value == data.status)?.label}
          </div>
        );
      },
    },
    {
      title: "Total refunds",
      dataIndex: "refunds",
      key: "refunds",
      width: 110,
      render: (_, data) => {
        if (data?.refunds?.length == 0) {
          return "No refunds";
        } else {
          return `${
            CurrenciesEnum?.find((o) => o.value == data.currency)?.label
          } ${data?.refunds.reduce((sum, refund) => sum + refund.amount, 0)}`;
        }
      },
    },
  ];

  const refundColumns = [
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      width: 120,
      render: (_, data) => {
        return `${CurrenciesEnum.find((o) => o.value == data?.transaction?.currency)?.label} ${formatAmount(data?.amount)}`;
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 70,
      render: (_, data) => {
        return (
          <div
            className="transactions_table_badge"
            style={{
              background: RefundTypesEnum.find((o) => o.value == data.type)
                ?.color,
            }}
          >
            {RefundTypesEnum.find((o) => o.value == data.type)?.label}
          </div>
        );
      },
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      width: 200,
      render: (_, data) => {
        return (
          <div
            style={{
              whiteSpace: "pre-line",
              fontSize: 13,
            }}
          >
            {data.reason}
          </div>
        );
      },
    },
    {
      title: "Document",
      dataIndex: "file",
      key: "file",
      width: 120,
      render: (_, data) => {
        if (data?.file) {
          return (
            <a
              href={showFile(data?.file?.name)}
              target="_blank"
              className="font-medium"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              See document
              <FaExternalLinkAlt style={{ marginLeft: 5 }} />
            </a>
          );
        }
      },
    },
    {
      title: "Paying user",
      dataIndex: "transaction.user.fullname",
      key: "paying_user",
      width: 120,
      render: (_, data) => {
        return data.transaction?.user?.fullname;
      },
    },
    {
      title: "Course",
      dataIndex: "transaction.invoice.course.name",
      key: "course",
      width: 120,
      render: (_, data) => {
        return data.transaction?.invoice?.course?.name;
      },
    },
    {
      title: "Date and time",
      dataIndex: "createTime",
      key: "createTime",
      width: 120,
      render: (_, data) => {
        return moment(data.createTime).format("DD MMM YYYY HH:mm");
      },
    },
  ];

  const items = [
    {
      key: "1",
      label: "Payments",
      children: (
        <div className="finance">
          <div className="payments_container">
            <div className="topic_all">
              <div className="topic_container">
                {/* courseId */}
                <Select
                  value={filters.courseId}
                  onChange={(value) => {
                    setFilters({ ...filters, courseId: value });
                    getTransactions(1, {
                      ...filters,
                      courseId: value,
                    });
                  }}
                  loading={getCoursesLoading}
                  disabled={getCoursesLoading}
                  onClear={(value) => {
                    setFilters({ ...filters, courseId: null });
                  }}
                  allowClear
                  placeholder="Select course"
                  optionLabelProp="label"
                  options={courses
                    .filter((o) => o.status == 1)
                    .map((item) => {
                      return { label: item.name, value: item.id };
                    })}
                />
                {/* date */}
                <RangePicker
                  value={filters.date}
                  onChange={(value) => {
                    setFilters({ ...filters, date: value });
                    getTransactions(1, {
                      ...filters,
                      date: value,
                    });
                  }}
                  disabledDate={(current) => {
                    return current && current > moment().endOf("day");
                  }}
                  size="small"
                  allowClear
                />
              </div>
            </div>
            <div className="payments_table">
              <Table
                dataSource={transactionsData}
                columns={columns}
                scroll={{ x: 1000 }}
                pagination={false}
                loading={loadings.getTransactions}
                rowClassName={(record) => {
                  if (record.refunds?.length > 0) {
                    return "row-warning";
                  }
                  return "";
                }}
              />
            </div>
            {!loadings.getTransactions &&
              transactionsData.map((data, index) => (
                <div className="payments_table_mobile" key={index}>
                  {/* course */}
                  <div>
                    <p>Course</p>
                    <span>{data.course?.name}</span>
                  </div>
                  {/* user */}
                  <div>
                    <p>User</p>
                    <span>{data.user.fullname}</span>
                  </div>
                  {/* price */}
                  <div>
                    <p>Price</p>
                    <span>{`${
                      CurrenciesEnum.find((o) => o.value == data.currency).label
                    } ${formatAmount(data.amount)}`}</span>
                  </div>
                  {/* date */}
                  <div>
                    <p>Date</p>
                    <span>{dateHelper(data.createTime)}</span>
                  </div>
                  {/* status */}
                  <div>
                    <p>Status</p>
                    <div
                      className="transactions_table_badge"
                      style={{
                        background: TransactionsEnum.find(
                          (o) => o.value == data.status,
                        )?.color,
                      }}
                    >
                      {
                        TransactionsEnum.find((o) => o.value == data.status)
                          ?.label
                      }
                    </div>
                  </div>
                </div>
              ))}
            {loadings.getTransactions ? (
              <div className="transactions_mobile_loading">
                {Array(4)
                  .fill()
                  .map((item, index) => (
                    <Skeleton
                      style={{
                        width: "100%",
                        height: 168,
                        borderRadius: 8,
                        marginBottom: 12,
                      }}
                      key={index}
                    />
                  ))}
              </div>
            ) : null}
          </div>
          <Pagination
            style={{ marginTop: 24 }}
            current={paginates.current}
            pageSize={10}
            onChange={(page) => {
              getTransactions(page, filters);
            }}
            total={paginates.total * 10}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: "Refunds",
      children: (
        <div className="finance">
          <div className="payments_container">
            <div className="topic_all">
              <div className="topic_container">
                {/* courseId */}
                <Select
                  value={filters.courseId}
                  onChange={(value) => {
                    setFilters({ ...filters, courseId: value });
                    getRefunds(1, {
                      ...filters,
                      courseId: value,
                    });
                  }}
                  loading={getCoursesLoading}
                  disabled={getCoursesLoading}
                  onClear={(value) => {
                    setFilters({ ...filters, courseId: null });
                  }}
                  allowClear
                  placeholder="Select course"
                  optionLabelProp="label"
                  options={courses
                    .filter((o) => o.status == 1)
                    .map((item) => {
                      return { label: item.name, value: item.id };
                    })}
                />
                {/* date */}
                <RangePicker
                  value={filters.date}
                  onChange={(value) => {
                    setFilters({ ...filters, date: value });
                    getRefunds(1, {
                      ...filters,
                      date: value,
                    });
                  }}
                  disabledDate={(current) => {
                    return current && current > moment().endOf("day");
                  }}
                  size="small"
                  allowClear
                />
              </div>
            </div>
            <div className="payments_table">
              <Table
                dataSource={refundsData}
                columns={refundColumns}
                scroll={{ x: 1000 }}
                pagination={false}
                loading={loadings.getRefunds}
              />
            </div>
            {!loadings.getRefunds &&
              refundsData.map((data, index) => (
                <div className="payments_table_mobile" key={index}>
                  {/* amount */}
                  <div>
                    <p>Amount</p>
                    <span>{`${CurrenciesEnum.find((o) => o.value == data?.transaction?.currency)?.label} ${formatAmount(data?.amount)}`}</span>
                  </div>
                  {/* type */}
                  <div>
                    <p>Type</p>
                    <div
                      className="transactions_table_badge"
                      style={{
                        width: 60,
                        background: RefundTypesEnum.find(
                          (o) => o.value == data.type,
                        )?.color,
                      }}
                    >
                      {RefundTypesEnum.find((o) => o.value == data.type)?.label}
                    </div>
                  </div>
                  {/* user */}
                  <div>
                    <p>Paying user</p>
                    <span>{data.transaction?.user?.fullname}</span>
                  </div>
                  {/* course */}
                  <div>
                    <p>Course</p>
                    <span>{data.transaction?.invoice?.course?.name}</span>
                  </div>
                  {/* createTime */}
                  <div>
                    <p>Date and time</p>
                    <span>
                      {moment(data.createTime).format("DD MMM YYYY HH:mm")}
                    </span>
                  </div>
                  {/* document */}
                  <div>
                    <p>Document</p>
                    <a
                      href={showFile(data?.file?.name)}
                      target="_blank"
                      className="font-medium"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      See document{" "}
                      <FaExternalLinkAlt style={{ marginLeft: 5 }} />
                    </a>
                  </div>
                  {/* reason */}
                  <div
                    style={{
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <p style={{ marginBottom: 5 }}>Reason</p>
                    <span style={{ whiteSpace: "pre-line", fontSize: 13 }}>
                      {data?.reason}
                    </span>
                  </div>
                </div>
              ))}
            {loadings.getRefunds ? (
              <div className="transactions_mobile_loading">
                {Array(4)
                  .fill()
                  .map((item, index) => (
                    <Skeleton
                      style={{
                        width: "100%",
                        height: 168,
                        borderRadius: 8,
                        marginBottom: 12,
                      }}
                      key={index}
                    />
                  ))}
              </div>
            ) : null}
          </div>
          <Pagination
            style={{ marginTop: 24 }}
            current={paginates.current}
            pageSize={10}
            onChange={(page) => {
              getRefunds(page, filters);
            }}
            total={paginates.total * 10}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (userProfile) {
      getCourses();
    }
  }, [userProfile]);

  useEffect(() => {
    if (userProfile) {
      switch (activeTab) {
        case "1":
          getTransactions(1, { courseId: null, date: null });
          setFilters({ courseId: null, date: null });
          break;
        case "2":
          getRefunds(1, { courseId: null, date: null });
          setFilters({ courseId: null, date: null });
          break;
        default:
          break;
      }
    }
  }, [userProfile, activeTab]);

  return (
    <Layout>
      <Tabs
        className="course_preview_tabs"
        activeKey={activeTab}
        onChange={(key) => {
          setActiveTab(key);
        }}
        items={items}
      />
    </Layout>
  );
};

export default Transactions;
